import { percentDecimal } from '../utils';

const calculatedRow = (row, defaults = {}) => {
    const { id, title, percentage, flywirePercentage, description, operator } = row;
    return {
        id,
        title,
        percentage,
        flywirePercentage,
        description,
        operator,

        open: false,

        current() {
            if (this.percentage === null) {
                return null;
            }

            return this.fullPatientRevenue * percentDecimal(this.percentage);
        },

        withFlywire() {
            if (this.flywirePercentage === null || this.current() === null) {
                return null;
            }

            return this.current() * percentDecimal(this.flywirePercentage);
        },

        init() {
            this.$data.addRow(this);
        },

        ...defaults,
    };
};

export default calculatedRow;
